import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import cashbackStrategyColumns from "./cashbackStrategyColumns";

type Props = {
  name: string;
  cardId: number;
  data?: any;
  editCard: (variables: any) => Promise<void>;
  fetchCardCashbackStrategies: () => void;
  currentStrategyId: number;
};

type Row = {
  id: number;
  type: string;
  description: string;
  value: number;
  updated_at: string;
  maximum_cashback_per_payment: number;
  maximum_total_payout: number;
  minimum_payment_amount: number;
  user_limit_amount: number;
  user_limit_type: string;
  strategy_limit_amount: number;
  cardId: number;
  editCard: (variables: any) => Promise<void>;
  fetchCardCashbackStrategies: () => void;
  selected: boolean;
};

const queryAllCashbackStrategies = gql`
  query AllCashbackStrategies($offset: Int, $limit: Int) {
    cashback_strategies(offset: $offset, limit: $limit) {
      id
      type
      description
      value
      updated_at
      maximum_cashback_per_payment
      maximum_total_payout
      minimum_payment_amount
      user_limit_amount
      user_limit_type
      strategy_limit_amount
    }
  }
`;

const packedRows = (passedProps: Props): Array<Row> => {
  var rows = passedProps.data.cashback_strategies || [];
  return rows.map(row => {
    return {
      ...row,
      cardId: passedProps.cardId,
      editCard: passedProps.editCard,
      fetchCardCashbackStrategies: passedProps.fetchCardCashbackStrategies,
      selected: passedProps.currentStrategyId === row.id
    };
  });
};

const withData = graphql<any, Props & PaginationProps>(
  queryAllCashbackStrategies,
  {
    options: ({ pagination: { offset, limit } }) => ({
      variables: {
        offset,
        limit
      }
    })
  }
);

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={cashbackStrategyColumns}
        defaultColumns={[
          "Select",
          "Type",
          "Description",
          "Value",
          "Maximum Cashback Per Payment",
          "Maximum Total Payout for Card",
          "Minimum Payment Amount",
          "User Limit Type",
          "User Limit Amount",
          "Strategy Limit Amount"
        ]}
        rows={packedRows(props)}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
